export default "__VITE_ASSET__CEH7fDOo__"